import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/lib/store";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, signup } = useApp();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = mode === "login" ? await login(email, password) : await signup(email, password, name);
      toast.success(`Welcome${u.name ? `, ${u.name}` : ""}`);
      navigate(u.role === "super_admin" || u.role === "admin" ? "/admin" : "/my-lab");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Authentication failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-16">
      <div className="glass-strong rounded-3xl p-8 sm:p-10 w-full max-w-md relative overflow-hidden">
        <div className="scan-line" />
        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-cyan-400/20 to-violet-500/20 border border-cyan-400/40 flex items-center justify-center mb-6">
          <FlaskConical className="text-cyan-300" size={20} />
        </div>
        <h1 className="font-serif text-3xl text-white">{mode === "login" ? "Enter Higher You" : "Join CG Labz"}</h1>
        <p className="text-xs font-mono text-slate-500 mt-2 uppercase tracking-widest">{mode === "login" ? "Sign in to your lab" : "Create your account"}</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          {mode === "signup" && (
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" data-testid="auth-name-input" className="bg-black/40 border-white/10" />
          )}
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="auth-email-input" className="bg-black/40 border-white/10" />
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="auth-password-input" className="bg-black/40 border-white/10" />
          <Button type="submit" disabled={loading} data-testid="login-form-submit-button" className="w-full btn-primary rounded-xl py-3 text-sm tracking-wide">
            {loading ? "Authenticating…" : mode === "login" ? "Sign In" : "Create Account"}
          </Button>
        </form>

        <button onClick={() => setMode(mode === "login" ? "signup" : "login")} data-testid="auth-toggle-mode"
          className="mt-5 text-xs font-mono text-slate-500 hover:text-cyan-300 transition-colors">
          {mode === "login" ? "Need an account? Sign up →" : "Have an account? Sign in →"}
        </button>
      </div>
    </div>
  );
}
